import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export const createSetupPasswordStyles = ({ palette, spacing }: Theme) => {
  return {
    textWrapper: css({
      margin: spacing([0, 1, 3, 1]),
    }),
    heading: css({
      color: palette.default.text,
      marginBottom: spacing(1),
    }),
    passwordValidationInfo: css({
      margin: spacing([1, 0]),
    }),
  };
};
